module.exports = __webpack_public_path__ + "img/hbBtn2.070feb1a.png";